import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const Toast = ({ message, severity, toastOpen, setToastOpen, duration = 3000, clickaway=false, clickToClose=false }) => {
	
	const handleClose = (event, reason) => {
		// If clickaway is false and the user clicks away from the Snackbar, don't close it
		if (!clickaway && reason === 'clickaway') {
			return;
		}

		setToastOpen(false);
	};

	return (
		<Snackbar
			open={toastOpen}
			onClose={handleClose}
			autoHideDuration={duration}
			anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
		>
			<Alert
				onClick={clickToClose ? handleClose : null}
				severity={severity}
				variant='filled'
				sx={{ width: '100%' }}
			>
				{message}
			</Alert>
		</Snackbar>
	);
};

export default Toast;